module.exports = __webpack_public_path__ + "static/media/cabbage.9d2136f8.svg";